import React, { useContext, useEffect, useState } from "react";
import Master from "components/helper/Master";
function skillMaster() {
  return (
    <Master name={{ name: "Skill Master" }} getUrl={"/Admin/getallskills"} deleteUrl={"/Admin/deleteskill"} updateurl={"/Admin/updateskill"} addurl={"/Admin/addskillset"} id={'SkillId'} />
  );
}

export default skillMaster;
